<template>
  <div>
    <div :style="{'background-color':app_color}">
      <div class="container">
        <div class="text-center m-5">
          <img width="200px" :src="logo_url" alt="logo">
        </div>
        <div class="row" v-if="android !== null || ios !== null">
          <div class="col-md-4 offset-md-4 m-auto text-center">
            <i class="fas fa-mobile-alt mb-2 icon-mobile"></i>
            <div class="ml-0 ml-md-5 app-info ">
              <h2>Baixe Nosso Aplicativo</h2>
              <p class="availability-text">Disponível para {{ android !== null ? 'Android' : '' }} {{
                  android !== null && ios !== null ? 'e' : ''
                }}
                {{ ios !== null ? 'IOS' : '' }}</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 offset-md-4" v-if="android !== null">
            <div class="ml-auto links-download">
              <a :href="android"><img class="m-2 center-align button-link" src="@/assets/imgs/img-google-play.png"></a>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 offset-md-4" v-if="ios !== null">
            <div class="ml-auto links-download">
              <a :href="ios"><img class="m-2 center-align button-link" src="@/assets/imgs/img-apple-store.png"></a>
            </div>
          </div>
        </div>
        <div class="row mb-0">
          <div class="col-md-3" v-if="showPosList">
            <a class="btn btn-white btn-animation-1 d-flex align-items-center justify-content-center btn-large"
               href="/pontos-de-venda" target="_blank">
              <span class="icon-text"><i class="fa-sm fas fa-map-marker-alt align-icon-left"></i>Pontos de venda</span>
            </a>
          </div>
          <div class="col-md-3">
            <a class="btn btn-white btn-animation-1 d-flex align-items-center justify-content-center btn-large"
               href="#" @click.prevent="openFaqPage">
            <span class="icon-text"><i
                class="fa-sm fas fa-question-circle align-icon-left"></i>FAQ</span>
            </a>
          </div>
          <div class="col-md-3">
            <a class="btn btn-white btn-animation-1 d-flex align-items-center justify-content-center btn-large"
               href="/termos-de-uso" target="_blank">
              <span class="icon-text"><i class="fa-sm fas fa-file-alt align-icon-left"></i>Termos de Uso</span>
            </a>
          </div>
          <div class="col-md-3">
            <a class="btn btn-white btn-animation-1 d-flex align-items-center justify-content-center btn-large"
               href="/" target="_blank">
              <span class="icon-text"><i class="fa-sm fas fa-globe align-icon-left"></i>Estacionar via Web</span>
            </a>
          </div>
          <div v-if="shouldRenderSectorMapButton" class="col-md-3">
            <a class="btn btn-white btn-animation-1 d-flex align-items-center justify-content-center btn-large"
               href="#" @click.prevent="openSectorMapButton">
              <span class="icon-text"><i class="fa-sm fas fa-map align-icon-left"></i>Mapa de Setores</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer-margin">
      <div class="text-center" v-if="info !== null">
        <h6>{{ info.name }}</h6>
        <h6><i class="fas fa-map-marker-alt"></i> {{ info.address }} - {{ info.city }}/{{ info.state }}</h6>
        <h6><i class="fas fa-phone"></i> {{ info.contact }}</h6>
      </div>
    </footer>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data: function () {
    return {
      android: null,
      ios: null,
      size: 200,
      info: null,
    }
  },
  mounted() {
    axios.get('/api/webdriver/landpage', {params: {tags: 'download_app_android'}}).then(res => {
      this.android = res.data.data[0].content;
      axios.get('/api/webdriver/landpage', {params: {tags: 'download_app_ios'}}).then(res => {
        this.ios = res.data.data[0].content;
        if (this.ios !== null || this.android !== null) {
          this.$emit('show', true);
        }
      })
    });
    axios.get('api/common/info/print').then(res => {
      this.info = res.data;
      if (this.info !== null) {
        this.$emit('show', true);
      }
    })
  },
  computed: {
    showPosList(){
      return process.env.VUE_APP_SHOW_POS_LIST === 'true';
    },
    logo_url() {
      return require('@/assets/imgs/logos/' + process.env.VUE_APP_LOGO_NAME);
    },
    app_color() {
      return process.env.VUE_APP_COLOR;
    },
    faq_link() {
      return process.env.VUE_APP_FAQ_LINK;
    },
    sector_map_link() {
      return process.env.VUE_APP_SECTOR_MAP_LINK;
    },
    shouldRenderSectorMapButton() {
      return !!process.env.VUE_APP_SECTOR_MAP_LINK;
    },
  },
  methods: {
    openFaqPage() {
      window.open(this.faq_link, '_blank');
    },
    openSectorMapButton() {

      window.open(this.sector_map_link, '_blank');
    }
  },
}
</script>
<style scoped>

.button-link {
  display: inline-block;
  transition: transform 0.3s ease-in-out;
}

.button-link:hover {
  transform: scale(1.2);
}

.fa-sm {
  font-size: 22px;
  color: black;
}

.d-flex {
  display: flex;
}

.btn .icon-text {
  display: flex;
  align-items: center;
}

.btn .icon-text i {
  margin-right: 5px;
}

.align-icon-left {
  margin-right: 10px;
}

.center-align {
  margin: 10px auto !important;
  display: table !important;
}

.icon-mobile {
  float: left;
  margin-top: 5px;
  margin-left: 35px;
  margin-right: -25px;
  color: #ffffff;
  font-size: 100px;
}

h2 {
  font-size: 34px;
  color: #ffffff;
  font-family: Roboto-Black;
}

h5 {
  font-family: Roboto-Black;
  font-size: 24px;
  color: #58595B;
}

p {
  font-size: 14px;
  color: #ffffff;
  font-family: Roboto-Regular;
  margin: 0;
}

.links-download {
  text-align: center;
}

@media only screen and (min-width: 1025px) {
  .links-download {
    text-align: right;
  }
}

.btn .icon-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn:link,
.btn:visited {
  text-decoration: none;
  text-transform: uppercase;
  position: relative;
  top: 0;
  left: 0;
  padding: 20px 40px;
  border-radius: 100px;
  display: inline-block;
  transition: all .5s;
}

.btn-white {
  background: #fff;
  color: #000;
}

.btn-large {
  width: 260px;
  height: 60px;
  margin: 10px;
}

.btn:hover {
  box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(-3px);
}

.btn:active {
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
  transform: translateY(-1px);
}

.btn::after {
  content: "";
  text-decoration: none;
  text-transform: uppercase;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 100px;
  display: inline-block;
  z-index: -1;
  transition: all .5s;
}

.btn-white::after {
  background: #fff;
}

.btn-animation-1:hover::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}

.footer-margin {
  margin-top: 15px;
  margin-bottom: 10px;
}

@media only screen and (max-width: 768px) {
  * {
    text-align: center !important;
  }

  p {
    margin-top: 20px;
    margin-bottom: 5px;
  }

  .btn-large {
    margin-left: auto;
    margin-right: auto;
  }

  .btn .icon-text {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .btn .icon-text i {
    margin-bottom: 5px;
  }

  .btn .icon-text span {
    font-size: 14px;
  }

  .app-info {
    margin-bottom: 10px;
  }

  .availability-text {
    margin-top: 5px;
  }

}
</style>
